import React from "react"
import { useSelector } from "react-redux"
import CustomButton from "components/Atoms/CustomButton"
import EditOrderItem from "./EditOrderItem"
const OrderItemsPanel = ({ orderId, closePanel }) => {
  const order = useSelector((state: any) =>
    state?.dispatch?.selectedOrders?.get(orderId)
  )
  const items = order?.orderItems

  return (
    <div>
      <div className="px-3 py-2 flex items-baseline">
        <CustomButton
          className="mr-3"
          icon="arrow-left"
          minimal
          onClick={closePanel}
        />
        <h6>
          {order?.user?.fullName} -{" "}
          <span className="vt-muted">{order?.shippingAddress?.village}</span>
          <div className="vt-muted text-sm">{order?.trackingCode}</div>
        </h6>
      </div>
      <section className="vt-panel">
        {items?.map((itm, index) => {
          return (
            <EditOrderItem
              itemIndex={index}
              orderId={orderId}
              key={itm?.id}
              item={itm}
            />
          )
        })}
      </section>

      <div className="p-3 vt-dispatch-panel-button">
        <CustomButton
          fill
          big
          intent="primary"
          icon="saved"
          text="Save"
          onClick={closePanel}
        />
      </div>
    </div>
  )
}

export default OrderItemsPanel
